<div class="container">

    <div class="page-header">
        <div class="page-header-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
                <polyline points="7 10 12 15 17 10"/>
                <line x1="12" y1="15" x2="12" y2="3"/>
            </svg>
        </div>
        <div style="flex:1">
            <h1>Download de XML de Compra</h1>
            <p>Notas de entrada do Aerosys · carregue a planilha com a chave de acesso e/ou o Num. NF</p>
        </div>
    </div>

    <!-- 1. ARQUIVO -->
    <div class="card">
        <div class="card-title">1. Arquivo com as notas</div>

        <div class="linha-arquivo">
            <label class="btn secondary" for="xml-compra-arquivo">Escolher arquivo (.xlsx, .xls, .csv)</label>
            <input id="xml-compra-arquivo" type="file" class="oculto" accept=".xlsx,.xls,.csv"
                   (change)="onArquivo($event)">
            <span class="nome-arquivo" *ngIf="nomeArquivo">{{ nomeArquivo }} · {{ totalLinhas }} linha(s)</span>
            <label class="check" *ngIf="nomeArquivo">
                <input type="checkbox" [(ngModel)]="primeiraLinhaCabecalho" (ngModelChange)="onCabecalhoChange()">
                Primeira linha é cabeçalho
            </label>
        </div>
        <p class="erro" *ngIf="erroArquivo()">{{ erroArquivo() }}</p>

        <ng-container *ngIf="colunas().length > 0">
            <div class="mapeamento">
                <div class="field">
                    <label>Coluna da CHAVE DE ACESSO</label>
                    <select [(ngModel)]="colChave">
                        <option [ngValue]="-1">(não usar)</option>
                        <option *ngFor="let c of colunas(); let i = index" [ngValue]="i">{{ c }}</option>
                    </select>
                </div>
                <div class="field">
                    <label>Coluna do NUM. NF</label>
                    <select [(ngModel)]="colNumNf">
                        <option [ngValue]="-1">(não usar)</option>
                        <option *ngFor="let c of colunas(); let i = index" [ngValue]="i">{{ c }}</option>
                    </select>
                </div>
                <button type="button" class="btn primary" [disabled]="!podeBuscar" (click)="buscar()">
                    {{ buscando() ? 'Buscando…' : 'Buscar no Aerosys' }}
                </button>
            </div>
            <small>Com a chave informada, ela identifica a nota exata; o Num. NF é usado nas linhas sem chave.</small>

            <div class="tabela-wrap pequena" *ngIf="previaLinhas().length">
                <table class="tabela">
                    <thead><tr><th *ngFor="let c of colunas()">{{ c }}</th></tr></thead>
                    <tbody>
                        <tr *ngFor="let l of previaLinhas()">
                            <td *ngFor="let c of colunas(); let i = index">{{ l[i] }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </ng-container>
    </div>

    <!-- 2. RESULTADO -->
    <div class="card" *ngIf="buscando() || buscou() || erroBusca()">
        <div class="card-title">2. Notas de entrada encontradas</div>

        <p class="status" *ngIf="buscando()">Consultando o Aerosys…</p>
        <p class="erro" *ngIf="erroBusca()">{{ erroBusca() }}</p>
        <p class="aviso" *ngIf="mensagem()">{{ mensagem() }}</p>

        <ng-container *ngIf="buscou()">
            <div class="acoes">
                <span class="resumo">
                    {{ notas().length }} nota(s) encontrada(s) · {{ notasComXml().length }} com XML ·
                    <a href="javascript:void(0)" (click)="mostrarNaoEncontrados = !mostrarNaoEncontrados">{{ naoEncontrados().length }} não encontrada(s)</a>
                </span>
                <div class="acoes-btn">
                    <label class="check">
                        <input type="checkbox" [(ngModel)]="separarPorMes">
                        Separar por mês (pastas AAAA-MM no ZIP)
                    </label>
                    <button type="button" class="btn secondary" [disabled]="qtdSelecionadas() === 0 || baixando()" (click)="baixarZip(false)">
                        Baixar selecionadas (ZIP) {{ qtdSelecionadas() ? '(' + qtdSelecionadas() + ')' : '' }}
                    </button>
                    <button type="button" class="btn primary" [disabled]="notasComXml().length === 0 || baixando()" (click)="baixarZip(true)">
                        {{ baixando() ? 'Gerando…' : 'Baixar todas (ZIP)' }}
                    </button>
                </div>
            </div>

            <div class="nao-encontrados" *ngIf="mostrarNaoEncontrados && naoEncontrados().length">
                <strong>Não encontradas no Aerosys como nota de entrada:</strong>
                <div *ngFor="let n of naoEncontrados()">NF {{ n.numNf || '—' }} · {{ n.chave || 'sem chave' }}</div>
            </div>

            <div class="tabela-wrap" *ngIf="notas().length">
                <table class="tabela">
                    <thead>
                        <tr>
                            <th class="col-sel"><input type="checkbox" [checked]="todasSelecionadas" (change)="alternarTodas()"></th>
                            <th>Nº NF</th>
                            <th>Série</th>
                            <th>Fornecedor</th>
                            <th>Emissão</th>
                            <th class="num">Total</th>
                            <th>Status</th>
                            <th>Chave de acesso</th>
                            <th>XML</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let n of notas()" [class.sem-xml]="!n.temXml">
                            <td class="col-sel"><input type="checkbox" [disabled]="!n.temXml" [checked]="selecionada(n)" (change)="alternar(n)"></td>
                            <td>{{ n.numNota }}</td>
                            <td>{{ n.serie }}</td>
                            <td>{{ n.fornecedor }}</td>
                            <td>{{ n.dataEmissao | date:'dd/MM/yyyy' }}</td>
                            <td class="num">{{ n.total | number:'1.2-2':'pt-BR' }}</td>
                            <td>{{ n.status }}</td>
                            <td class="chave">{{ n.chave }}</td>
                            <td>{{ n.temXml ? 'Sim' : 'Não' }}</td>
                            <td class="col-acoes">
                                <button type="button" class="btn-mini" [disabled]="!n.temXml || baixando()" (click)="baixarUma(n)">Baixar XML</button>
                                <button type="button" class="btn-mini" [disabled]="!n.temXml || carregandoPreview()" (click)="testarNota(n)">Testar</button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </ng-container>
    </div>

    <!-- 3. TESTAR XML -->
    <div class="card">
        <div class="card-title">3. Testar XML (capa e itens)</div>
        <div class="linha-arquivo">
            <label class="btn secondary" for="xml-compra-teste">Carregar um arquivo XML</label>
            <input id="xml-compra-teste" type="file" class="oculto" accept=".xml,text/xml,application/xml"
                   (change)="onArquivoXml($event)">
            <span class="nome-arquivo">ou use o botão “Testar” de uma nota da lista acima.</span>
            <button type="button" class="btn secondary" *ngIf="preview()" (click)="fecharPreview()">Limpar</button>
        </div>
        <p class="status" *ngIf="carregandoPreview()">Carregando XML…</p>
        <p class="erro" *ngIf="erroPreview()">{{ erroPreview() }}</p>

        <ng-container *ngIf="preview() as p">
            <p class="arquivo-preview">Arquivo: <strong>{{ p.arquivo }}</strong></p>
            <div class="avisos" *ngIf="p.avisos.length">
                <div *ngFor="let a of p.avisos">⚠ {{ a }}</div>
            </div>
            <div class="avisos ok" *ngIf="!p.avisos.length">XML válido, sem inconsistências encontradas.</div>

            <h3 class="sub">Capa</h3>
            <div class="grade-campos">
                <div *ngFor="let c of p.capa"><span>{{ c.rotulo }}</span><strong>{{ c.valor }}</strong></div>
            </div>
            <div class="duas-colunas">
                <div>
                    <h3 class="sub">Emitente</h3>
                    <div class="grade-campos">
                        <div *ngFor="let c of p.emitente"><span>{{ c.rotulo }}</span><strong>{{ c.valor }}</strong></div>
                    </div>
                </div>
                <div>
                    <h3 class="sub">Destinatário</h3>
                    <div class="grade-campos">
                        <div *ngFor="let c of p.destinatario"><span>{{ c.rotulo }}</span><strong>{{ c.valor }}</strong></div>
                    </div>
                </div>
            </div>
            <h3 class="sub">Totais</h3>
            <div class="grade-campos">
                <div *ngFor="let c of p.totais"><span>{{ c.rotulo }}</span><strong>{{ c.valor }}</strong></div>
            </div>

            <h3 class="sub">Itens ({{ p.itens.length }})</h3>
            <div class="tabela-wrap">
                <table class="tabela">
                    <thead>
                        <tr>
                            <th>#</th><th>Código</th><th>Descrição</th><th>NCM</th><th>CFOP</th><th>UN</th>
                            <th class="num">Qtde</th><th class="num">Vlr unit.</th><th class="num">Vlr total</th>
                            <th class="num">ICMS</th><th class="num">IPI</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let i of p.itens">
                            <td>{{ i.item }}</td>
                            <td>{{ i.codigo }}</td>
                            <td class="desc">{{ i.descricao }}</td>
                            <td>{{ i.ncm }}</td>
                            <td>{{ i.cfop }}</td>
                            <td>{{ i.un }}</td>
                            <td class="num">{{ i.qtde | number:'1.0-4':'pt-BR' }}</td>
                            <td class="num">{{ i.vlrUnit | number:'1.2-4':'pt-BR' }}</td>
                            <td class="num">{{ i.vlrTotal | number:'1.2-2':'pt-BR' }}</td>
                            <td class="num">{{ i.icms | number:'1.2-2':'pt-BR' }}</td>
                            <td class="num">{{ i.ipi | number:'1.2-2':'pt-BR' }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </ng-container>
    </div>
</div>
